import KeyFilter from 'primevue/keyfilter';
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('uppercase', (item) => {
        item.value = item.value.toUpperCase();
    });
    nuxtApp.vueApp.directive('capitalize', (item) => {
        item.value = item.value.charAt(0).toUpperCase() + item.value.slice(1).toLowerCase();
    });
    nuxtApp.vueApp.directive('keyfilter', KeyFilter);
    nuxtApp.vueApp.directive('required_label', {
        mounted(el) {
            if (el && (el.tagName === 'LABEL' || el.tagName === 'SMALL')) {
                const span = document.createElement('span');
                span.style.color = '#ef4444';
                span.style.marginLeft = '2px';
                span.textContent = '*';
                el.appendChild(span);
            }
        },
    });
});
